import React from 'react';
import { FieldHelpProps, helpId } from '@rjsf/utils';

/**
 * Renders ui:help for every field at every nesting depth.
 * String help (from connector ui_schemas) gets the same muted typography as
 * field descriptions — rjsf's default is a bare 16px help-block paragraph.
 * React-element help (the validation-error rows injected by generateUISchema)
 * is rendered unchanged.
 */
const CustomFieldHelpTemplate = ({ help, idSchema }: FieldHelpProps) => {
  if (!help || (typeof help === 'string' && help.trim() === '')) {
    return null;
  }

  const id = helpId(idSchema);

  if (typeof help === 'string') {
    return (
      <p id={id} className="mt-1 text-body-sm text-ui-text-primary-text">
        {help}
      </p>
    );
  }

  return <div id={id}>{help}</div>;
};

export default CustomFieldHelpTemplate;
